module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Histori Surat Jalan\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "type": "primary",
      "loading": _vm.loadingSearch,
      "icon": "ios-search",
      "size": "small"
    },
    on: {
      "click": _vm.getReceived
    },
    slot: "extra"
  }, [(!_vm.loadingSearch) ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Wait.....")])]), _vm._v(" "), _vm._l((_vm.invoicesReceived), function(invoice) {
    return _c('div', [_c('Row', [_c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_c('Tag', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("P." + _vm._s(invoice.containerCode) + " - " + _vm._s(_vm._f("showDateFormatted")(invoice.containerLoadDate)))])], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" \n                "), (invoice.invoiceReceiveDos.length > 0) ? _c('Poptip', {
      attrs: {
        "placement": "top",
        "trigger": "hover"
      }
    }, [_c('Button', {
      attrs: {
        "type": "info",
        "size": "small"
      }
    }, [_vm._v(_vm._s(invoice.invoiceReceiveDos.length))]), _vm._v(" "), _c('div', {
      staticClass: "api",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('ul', [_c('b', [_vm._v(_vm._s(invoice.markingCode))]), _vm._v(" "), _vm._l((invoice.invoiceReceiveDos), function(item) {
      return _c('li', [_vm._v("\n                                - " + _vm._s(item.notes) + "\n                            ")])
    })], 2)])], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "10"
      }
    }, [_vm._v(_vm._s(invoice.markingCode))])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff9a42f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceReceiveHistory.vue
// module id = 1864
// module chunks = 1